export const NOTIFICATION_TYPE = {
  AWARD: 'award',
  GOAL_COMMENT_MENTION: 'goal-comment-mention',
  KR_COMMENT_MENTION: 'kr-comment-mention',
  INITIATIVE_COMMENT_MENTION: 'initiative-comment-mention',
  INITIATIVE_DESCRIPTION_MENTION: 'initiative-description-mention',
  REACTION: 'reaction'
}
